import * as React from "react"
import { usePrevious } from "react-use"

/**
 * Returns the last distinct value. For instance with a sequence of inputs:
 * input:  0 0 0 1 1 2 2 2 0
 * output: u 0 0 0 0 1 1 1 2
 *
 * This differs from usePrevious, which returns the previous value even if it is the same as the current value:
 *
 * input:  0 0 0 1 1 2 2 2 0
 * output: u 0 0 0 1 1 2 2 2
 */
export default function usePreviousDistinct<T>(value: T) {
  const previous = usePrevious(value)
  const lastDistinctRef = React.useRef<T | undefined>(undefined)

  // This can't be an effect because it would be run after the hook returns.
  if (previous !== undefined && previous !== value) {
    lastDistinctRef.current = previous
  }

  return lastDistinctRef.current
}
